import React, { useContext, useEffect, useMemo, useState, useCallback, useRef } from "react";
import Screen from '../components/Screen';
import { calculateHoursUntil, i18nValue } from '../functions';
import { UserContext } from "../context/user";
import { useParams } from 'react-router';
import { CheckInContext } from "../context/checkin";
import { HotelContext } from "../context/hotel";
import { T, TF } from "react-translator-component";
import { Payment } from "../components/Payment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckSquare,
  faSquare

} from "@fortawesome/free-solid-svg-icons";
// import { Rating } from '@smastrom/react-rating'
import Rate from "../components/Rate";
import useCheckInActions from "../hooks/useCheckInActions";
import { isHostzBlackSummit, getBlackSummitDepositAmount } from "../components/CheckIn/hotelConditions";


export const PaymentScreen = () => {
  const { id } = useParams();
  const { language } = useContext(UserContext)
  const { data: checkIn, getBalancePaymentUrl } = useContext(CheckInContext);
  const { data: hotel } = useContext(HotelContext);
  const { getBalance } = useCheckInActions();

  console.log('31ene params', id);

  // const handlePayButtonClick = () => {
  //   getBalancePaymentUrl().then(r => {
  //     r = JSON.parse(r);
  //     if (r.url) {
  //       window.location.href = r.url;
  //     }
  //   })
  // }

  const [loading, setLoading] = useState(true);
  const [balance, setBalance] = useState(null);
  const [isPaidDepositGaarantee, setIsPaidDepositGaarantee] = useState(false);


  const [balanceDetail, setBalanceDetail] = useState([]);
  const [paymentState, setPaymentState] = useState('initial');
  const [cartRequired, setCartRequired] = useState([]);
  const [cart, setCart] = useState([]);
  const [totalCart, setTotalCart] = useState({});

  const checkoutRef = useRef(null);
  const [dropinInstance, setDropinInstance] = useState(null);


  const countryCode = useMemo(() => {
    const cc = checkIn?.passengers?.[0]?.residence || checkIn?.passengers?.[0]?.nationality || null;
    console.log('20ene - cc', cc);
    return cc || "CH"; //TODO_G: Fijo por ahora
  }, [checkIn?.passengers]);

  useEffect(() => {

    if (id && (id === "balance" || id === "depositGuarantee")) {

      // Voy a buscar el balance
      getBalance(hotel?.id, checkIn?.id).then(res => {
        console.log('31ene - balance 222', res);
        setBalance(res?.balance);
        setIsPaidDepositGaarantee(res?.depositGuarantee?.paid)
        setLoading(false);
      });

    }

  }, []);
  let guaranteeDepositAmount = 500
  let guaranteeDeposit100Hotels = [
    // "511e8df9-672d-42b1-9711-d82beb7baf64", // dev
    "efcf9764-9157-4454-9d24-76a053906322" // betahous
  ]
  if (guaranteeDeposit100Hotels.includes(hotel?.id))
    guaranteeDepositAmount = 100


  useEffect(() => {

    console.log('31ene cart', cart);
    console.log('31ene balanceDetail', balanceDetail)

    let totalAmount = 0;

    if (cart && balanceDetail) {
      console.log('PAYMENT - 000: setTotalCart -> Sólo Depósito de Garantía 1111', totalCart);
      if (!totalCart.onlyDepositGuarantee) {
        totalAmount = balanceDetail
          .filter(item => cart.includes(item.id) && item.id !== "GuaranteeDeposit") // Filtrar por IDs en `selectedIds`
          .reduce((sum, item) => sum + item.amount, 0);
      } else {
        totalAmount = guaranteeDepositAmount;
      }
    }
    // if (cart && balanceDetail) {
    //   totalAmount = balanceDetail
    //     .filter(item => cart.includes(item.id) && item.id !== "GuaranteeDeposit") // Filtrar por IDs en `selectedIds`
    //     .reduce((sum, item) => sum + item.amount, 0);
    // }

    const _amounts = {
      security_deposit: {
        value: 0,
        currency: paymentCurrency
      },
      webcheckin: {
        value: totalAmount * 100,
        currency: paymentCurrency
      },
      add_ons: {
        value: 0,
        currency: paymentCurrency
      }
    }

    setTotalCart({ ...totalCart, amount: 100 * totalAmount, amounts: _amounts });
  }, [cart]);


  useEffect(() => {

    let onlyDepositGuarantee = false;

    if (balance) {

      console.log('31ene - balance 1', balance);
      if (balance.charges) {

        let arrayWithIds = Object.entries(balance.charges)
          .filter(([key, value]) => value.amount > 0)
          .map(([key, value]) => ({
            ...value,
            id: key
          }));

        console.log('31ene - arrayWithIds', arrayWithIds);

        if (!arrayWithIds) {
          arrayWithIds = [];
        }
        if (id === "depositGuarantee") {
          arrayWithIds = [];
        }


        console.log('31ene - showGuaranteeDeposit', showGuaranteeDeposit);
        console.log('31ene - hotel?.id', hotel?.id);

        if (showGuaranteeDeposit && !isPaidDepositGaarantee) {
          if (arrayWithIds.length == 0) {
            onlyDepositGuarantee = true;
          }
          arrayWithIds.unshift(
            {
              amount: guaranteeDepositAmount,
              id: "GuaranteeDeposit",
              name: T("payments.guarantee-deposit"),
              qty: 1,
              desc: T("payments.guarantee-deposit-desc")
            }
          );
        }
        setBalanceDetail(arrayWithIds);

        let items = Object.keys(balance.charges);
        if (!items) {
          items = [];
        }
        if (id === "depositGuarantee") {
          items = [];
        }
        if (showGuaranteeDeposit && !isPaidDepositGaarantee) {
          items.unshift("GuaranteeDeposit");
        }
        if (Array.isArray(noShowItemInCart)) {
          noShowItemInCart.forEach((el) => {
            if (!items.includes(el)) {
              items.unshift(el);
            }
          });
        }

        setCartRequired(items);
        setCart(items);
      }

      if (!onlyDepositGuarantee) {
        // Flujo normal
        setTotalCart({
          checkInId: checkIn.id,
          reference: 'WebCheckin Payment',
          name: '.',
          description: '..',
          amount: 0,
          currency: checkIn.balance?.currency || "CHF",
          chargeDepositGuarantee: showGuaranteeDeposit
        });
      } else {
        // Sólo Depósito de Garantía

        console.log('PAYMENT - 000: setTotalCart -> Sólo Depósito de Garantía');

        setTotalCart({
          checkInId: checkIn.id,
          reference: `${T("payments.guarantee-deposit")} - Payment`,
          name: '.',
          description: '..',
          amount: guaranteeDepositAmount,
          currency: checkIn.balance?.currency || "CHF",
          chargeDepositGuarantee: showGuaranteeDeposit,
          onlyDepositGuarantee: onlyDepositGuarantee
        });
      }

    }
  }, [balance, isPaidDepositGaarantee])

  const { showGuaranteeDeposit, showOptionNoPayment, noShowItemInCart, more72hs } = useMemo(() => {
    if (!checkIn.reservation) return { noShowItemInCart: [], showGuaranteeDeposit: false, showOptionNoPayment: false, more72hs: false };

    let noShowItemInCart = [];
    let showGD = true;
    let showOmmit = false;
    let isMore72hs = false;

    console.log('PAYMENT - checkin', checkIn);

    const hours = calculateHoursUntil(checkIn.reservation.arrival);
    console.log('PAYMENT - hours to arrive', hours);
    if (hours >= 72) {
      // Faltan más de 72 horas, no muestro garantía y permito continuar
      showGD = false;
      showOmmit = true;
      isMore72hs = true;
    }

    // Criterios por channel
    if (!checkIn.channel?.toLowerCase().includes('direct')) {
      noShowItemInCart = ['Accommodation'];
    }
    if (checkIn.channel?.toLowerCase().includes('airbnb')) {
      showGD = false;
    }
    if (hotel.id === "9983de2a-9f3e-4c75-9fb9-62e9855681e8") {
      showGD = false;
    }

    return { noShowItemInCart: noShowItemInCart, showGuaranteeDeposit: showGD, showOptionNoPayment: showOmmit, more72hs: isMore72hs };

  }, [checkIn?.reservation]);

  const paymentCurrency = useMemo(() => {
    if (checkIn?.balance?.currency) {
      return checkIn.balance.currency
    }
    return "CHF"
  }, [checkIn]);

  const paymentResult = (res, detail) => {
    console.log('paymentResult - res', res);
    console.log('paymentResult - detail', detail);

    if (res == 'Loading') {
      console.log('setPaymentState', 'loading-component');
      setPaymentState('loading-component');
    }
    if (res == 'InProgress') {
      console.log('setPaymentState', 'in-progress');
      setPaymentState('in-progress');
    }
    if (res == 'Authorised') {
      console.log('setPaymentState', 'done');
      setPaymentState('done');
    }
    if (res == 'Refused' || res == 'Error') {
      console.log('setPaymentState', 'error');
      setPaymentState('error');
    }

  }

  if (loading || isPaidDepositGaarantee) {
    return <Screen backUrl={`./checkin/status`} section={`payment`} title={'Payment'}>
      {loading && (
        <div className="loading text-center mt-5 p-10">
          <div className="spinner-border" role="status"></div>
        </div>
      )}
      {!loading && (
        <p className="text-center p-4 mt-4">{T('payments.guarantee-deposit-paid')}</p>
      )}
    </Screen>
  }

  return (
    <Screen
      section={`payment`}
      title={'Payment'}
      backUrl={`./checkin/status`}
    >
      {/* {id === "balance" && <p>Pago de Saldo<br />999 EUR</p>} */}

      {/* <button onClick={handlePayButtonClick}>Pay</button> */}

      <div className="payment-container mb-4">
        <div ref={checkoutRef} className="payment">

        </div>
      </div>

      {paymentState == "initial" && (
        <>
          {showGuaranteeDeposit && isHostzBlackSummit(hotel.id) && (
            <p className="pt-2 mb-4 text-muted general-text-sm text-center" style={{ lineHeight: 1.25 }}>
              {T("payments.msg_guarantee")}
            </p>
          )}

          {more72hs && isHostzBlackSummit(hotel.id) && (
            <p className="pt-2 mb-4 text-muted general-text-sm text-center" style={{ lineHeight: 1.25 }}>
              {TF("payments.msg_guarantee_72hs", [getBlackSummitDepositAmount(hotel.id, checkIn)])}
            </p>
          )}

          <p className="pt-2 general-text-sm text-center">{T("payments.items-pay-with-deposit")}</p>

          {(balanceDetail && balanceDetail.map((el, idx) => {
            const isRequired = cartRequired.includes(el.id);
            const inCart = cart.includes(el.id);
            return (
              <div
                key={`balance-detail-${idx}`}
                className="text-center mb-1"
                style={{
                  background: "white",
                  color: inCart ? "#5b2e5c" : "#AAA",
                  border: inCart ? "1px solid #5b2e5c" : "1px solid #EEE",
                  fontWeight: inCart ? "bold" : "lighter",
                  borderRadius: 8,
                  padding: "8px 10px"
                }}
                onClick={() => {
                  if (isRequired) return;
                  // toggleCart(el.id)
                }}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-between align-items-center">
                    {!isRequired && (
                      <FontAwesomeIcon
                        icon={inCart ? faCheckSquare : faSquare}
                        style={{ fontSize: 16, color: inCart ? "#5b2e5c" : "#AAA" }}
                        className="mr-2"
                      />
                    )}
                    <div className="text-left" style={{ lineHeight: 1 }}>{el.name}
                      {el.qty > 1 && (<small>{el.qty && ` (x${el.qty})`}</small>)}
                    </div>
                  </div>
                  <div>{el.amount.toFixed(2)} {paymentCurrency}</div>
                </div>
                {el.desc && (<div className="text-left font-size-sm" style={{ lineHeight: 1 }}><small>{el.desc}</small></div>)}
              </div>
            )
          }))}
        </>
      )}

      {(paymentState === "initial" || paymentState === "loading-component" || paymentState === "error") && (
        <>
          {(totalCart && (totalCart.amount > 0))
            ?
            <>
              {(paymentState === "initial") && <div className="d-flex py-3" style={{ flex: 1, justifyContent: "space-between" }}>
                <div>{T("general.country")}: <b>{countryCode}</b></div>
                <div>{T("payments.total-to-pay")}: <b>{(totalCart.amount / 100).toFixed(2)} {paymentCurrency}</b></div>
              </div>}
              <Payment
                text={paymentState != "error" ? T("payments.pay") : T("payments.retry-pay")}
                checkInId={checkIn.id}
                paymentDetail={totalCart}
                paymentResult={paymentResult}
                checkoutRef={checkoutRef}
                dropinInstance={dropinInstance}
                countryCode={countryCode}
                setDropinInstance={setDropinInstance}
              />
            </>
            :
            <>

            </>
          }
        </>
      )}





    </Screen>
  );
}

export default PaymentScreen;